import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";

const links = [
  { to: "/", label: "Početna" },
  { to: "/restoran", label: "Restoran" },
  { to: "/banket-sala", label: "Banket sala" },
  { to: "/smestaj", label: "Smeštaj" },
  { to: "/galerija", label: "Galerija" },
  { to: "/kontakt", label: "Kontakt" }
];

export function Navbar() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  useEffect(() => {
    if (!open) return;
    const onKeyDown = (event) => {
      if (event.key === "Escape") setOpen(false);
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open]);

  const handleNavigate = (to) => {
    navigate(to);
    setOpen(false);
  };

  return (
    <header className="navbar">
      <div className="navbar-inner">
        <button className="navbar-logo" onClick={() => handleNavigate("/")}>
          <img
            src="/logo.png"
            alt="RESTORAN KRČMA logo"
            className="logo-image"
            width="220"
            height="100"
          />
          <div className="logo-text">
            <span className="logo-title">RESTORAN KRČMA</span>
          </div>
        </button>
        <nav className="navbar-nav">
          {links.map((link) => (
            <NavLink
              key={link.to}
              className={({ isActive }) =>
                `nav-link ${isActive ? "is-active" : ""}`
              }
              to={link.to}
            >
              {link.label}
            </NavLink>
          ))}
          <a className="btn btn-primary btn-small nav-cta" href="tel:034354571">
            POZOVITE NAS
          </a>
        </nav>
        <button
          className={`navbar-toggle ${open ? "is-open" : ""}`}
          aria-label={open ? "Zatvori meni" : "Otvori meni"}
          aria-expanded={open}
          aria-controls="mobile-navigation"
          onClick={() => setOpen((v) => !v)}
        >
          <span />
          <span />
        </button>
      </div>
      <div id="mobile-navigation" className={`navbar-mobile ${open ? "is-open" : ""}`}>
        <div className="navbar-mobile-inner">
          {links.map((link) => (
            <NavLink
              key={link.to}
              className={({ isActive }) =>
                `nav-link-mobile ${isActive ? "is-active" : ""}`
              }
              to={link.to}
              onClick={() => setOpen(false)}
            >
              {link.label}
            </NavLink>
          ))}
          <a className="btn btn-primary btn-full nav-mobile-cta" href="tel:034354571">
            POZOVITE NAS
          </a>
        </div>
      </div>
    </header>
  );
}

